<template>
  <div>
    <div class="p-2">
      <span class="">{{ toDay }}</span>
    </div>
    <div class="table-responsive text-nowrap">
      <table class="table table-bordered m-0">
        <thead>
          <tr>
            <th>งวดหวย</th>
            <th class="text-center">สี่ตัวบน</th>
            <th class="text-center">สามตัวบน</th>
            <th class="text-center">สองตัวล่าง</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="dataList.length !== 0">
            <tr data-target="#myCarousel1" v-bind:data-slide-to="index" v-for="(item, index) in dataList"
              v-bind:class="index === 0 ? 'active' : ''" v-bind:key="index">
              <template v-if="index != 10">

                <td>
                  <span class="d-flex align-items-center">
                    <span class="flag-icon me-2" v-bind:class="getIconFlag(item.title)"></span>
                    <div>
                      <strong class="d-block">{{ item.title }}</strong><!--<small>13/18/24</small> -->
                    </div>
                  </span>
                </td>
                <td class="text-center">

                  <strong class="text-dark"> {{ item.first_prize.substring(item.first_prize.length - 4,
                    item.first_prize.length) }}</strong>
                  <!-- {{   item.first_prize  }} -->
                </td>
                <td class="text-center">
                  <strong class="text-dark"> {{ item.threeDigit ? item.threeDigit.substring(item.threeDigit.length - 3, item.threeDigit.length) : "xxx" }}</strong>
                </td>
                <td class="text-center">
                  <strong class="text-dark"> {{ item.twoDigit ? item.twoDigit : "xx" }}</strong>
                </td>
              </template>
            </tr>
          </template>
          <template v-else>
            <tr class="">
              <td colspan="3">

                <div class="empty-list ">
                  <i class="empty-state-icon icon-list"></i>
                  <h4>ไม่มีข้อมูล</h4>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { getFlagIcons } from '@/utils'
export default {
  props: {
    dataList: {
      type: Array,
      defaults: []
    },
    toDay: {
      type: String,
      default: ''
    }
  },
  created: function () { },
  methods: {
    getIconFlag (title) {
      if (title) {
        return getFlagIcons(title)
      } else {
        return ''
      }
    }
  },
  computed: {}
}
</script>
